import React from 'react';
import { Link } from 'react-router-dom';

const PortfolioSliderPage = () => {
    return (
        <main id="infocolors-main">
            <div className="infocolors-slider-wrapper">
                <div className="swiper infocolors-slider" data-duration="800" data-effect="slide">
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <img className="infocolors-lazy" src="img/null.png" data-src="img/portfolio/portfolio01-land.jpg" alt="" width="1920" height="1280" />
                            <div className="infocolors-slide-content">
                                <div className="infocolors-slide-content-inner infocolors-slide-post-title">
                                    <span className="infocolors-meta">Branding</span>
                                    <h4>Curology</h4>
                                </div>
                                <Link to="/portfolio-post"></Link>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <img className="infocolors-lazy" src="img/null.png" data-src="img/portfolio/portfolio02-land.jpg" alt="" width="1920" height="1280" />
                            <div className="infocolors-slide-content">
                                <div className="infocolors-slide-content-inner infocolors-slide-post-title">
                                    <span className="infocolors-meta">Advertising</span>
                                    <h4>Cookie Dough</h4>
                                </div>
                                <Link to="/portfolio-post"></Link>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <img className="infocolors-lazy" src="img/null.png" data-src="img/portfolio/portfolio03-land.jpg" alt="" width="1920" height="1280" />
                            <div className="infocolors-slide-content">
                                <div className="infocolors-slide-content-inner infocolors-slide-post-title">
                                    <span className="infocolors-meta">Marketing</span>
                                    <h4>Gaming Power</h4>
                                </div>
                                <Link to="/portfolio-post"></Link>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <img className="infocolors-lazy" src="img/null.png" data-src="img/portfolio/portfolio04-land.jpg" alt="" width="1920" height="1280" />
                            <div className="infocolors-slide-content">
                                <div className="infocolors-slide-content-inner infocolors-slide-post-title">
                                    <span className="infocolors-meta">Advertising</span>
                                    <h4>Riot Energy</h4>
                                </div>
                                <Link to="/portfolio-post"></Link>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <img className="infocolors-lazy" src="img/null.png" data-src="img/portfolio/portfolio05-land.jpg" alt="" width="1920" height="1280" />
                            <div className="infocolors-slide-content">
                                <div className="infocolors-slide-content-inner infocolors-slide-post-title">
                                    <span className="infocolors-meta">Marketing</span>
                                    <h4>Smoothie</h4>
                                </div>
                                <Link to="/portfolio-post"></Link>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <img className="infocolors-lazy" src="img/null.png" data-src="img/portfolio/portfolio06-land.jpg" alt="" width="1920" height="1280" />
                            <div className="infocolors-slide-content">
                                <div className="infocolors-slide-content-inner infocolors-slide-post-title">
                                    <span className="infocolors-meta">Branding</span>
                                    <h4>Positive Beverage</h4>
                                </div>
                                <Link to="/portfolio-post"></Link>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <img className="infocolors-lazy" src="img/null.png" data-src="img/portfolio/portfolio07-land.jpg" alt="" width="1920" height="1280" />
                            <div className="infocolors-slide-content">
                                <div className="infocolors-slide-content-inner infocolors-slide-post-title">
                                    <span className="infocolors-meta">Branding</span>
                                    <h4>Fashion Makeup</h4>
                                </div>
                                <Link to="/portfolio-post"></Link>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <img className="infocolors-lazy" src="img/null.png" data-src="img/portfolio/portfolio08-land.jpg" alt="" width="1920" height="1280" />
                            <div className="infocolors-slide-content">
                                <div className="infocolors-slide-content-inner infocolors-slide-post-title">
                                    <span className="infocolors-meta">Advertising</span>
                                    <h4>Kombucha</h4>
                                </div>
                                <Link to="/portfolio-post"></Link>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <img className="infocolors-lazy" src="img/null.png" data-src="img/portfolio/portfolio09-land.jpg" alt="" width="1920" height="1280" />
                            <div className="infocolors-slide-content">
                                <div className="infocolors-slide-content-inner infocolors-slide-post-title">
                                    <span className="infocolors-meta">Marketing</span>
                                    <h4>Alliance</h4>
                                </div>
                                <Link to="/portfolio-post"></Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="infocolors-slider-nav on-sides">
                    <button className="infocolors-slider-prev">
                        <span className="infocolors-icon infocolors-icon-arrow-left"></span>
                    </button>
                    <button className="infocolors-slider-next">
                        <span className="infocolors-icon infocolors-icon-arrow-right"></span>
                    </button>
                </div>
            </div>
        </main>
    );
};

export default PortfolioSliderPage;
